import { AxiosInstance } from "axios"

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}
export const formErrorMessage = (error: any) => {
  // console.error(error)
  let errorMessage: string
  if (error.response && error.response.data && error.response.data.message) {
    errorMessage = error.response.data.message
  } else if (error.message) {
    errorMessage = error.message
  } else {
    errorMessage = error.toString()
  }

  return errorMessage
}
export const wrapperApiRequest = (api: AxiosInstance) => {
  return async (
    method: HttpMethod,
    endpoint: string,
    payload: Record<string, any> = {},
    params: Record<string, any> = {},
  ) => {
    try {
      let response
      switch (method) {
        case HttpMethod.GET:
          response = await api.get(endpoint, { params })
          break
        case HttpMethod.POST:
          response = await api.post(endpoint, payload)
          break
        case HttpMethod.PUT:
          response = await api.put(endpoint, payload)
          break
        case HttpMethod.DELETE:
          response = await api.delete(endpoint, { data: payload })
          break
        default:
          throw new Error(`Unsupported method: ${method}`)
      }
      return response.data
    } catch (error: any) {
      const errorMessage = formErrorMessage(error)
      return { error: errorMessage }
    }
  }
}
